/* @flow */

import { useQuery, type QueryResult, useMutation } from 'react-query';
import {
    businessUnit as businessUnitApi,
    businessUnitSettings as businessUnitSettingsApi
} from 'platform/api';
import useClientId from 'common/hooks/useClientId';
import { BusinessUnitList } from 'common/models/internal/BusinessUnits';

export const useBusinessUnits = (): QueryResult<BusinessUnitList> => {
    const clientId = useClientId();
    return useQuery({
        queryKey: ['client', clientId, 'businessUnit'],
        queryFn: async () => {
            const data = await businessUnitApi.fetch({ clientId });
            return BusinessUnitList.fromJS(data);
        }
    });
};

type Params = {
    businessUnitId: string
};

export const useBusinessUnitSettings = () => {
    const clientId = useClientId();
    return useMutation(async ({ businessUnitId }: Params) => {
        const data = await businessUnitSettingsApi.fetch({
            clientId,
            businessUnitId
        });
        return data;
    });
};

type UpdateParams = {
    businessUnitId: string,
    requestPayload: $FixMe
};

export const useUpdateBusinessUnitSettings = () => {
    const clientId = useClientId();
    return useMutation(
        async ({ businessUnitId, requestPayload }: UpdateParams) => {
            const data = await businessUnitSettingsApi.post(
                { clientId, businessUnitId },
                requestPayload
            );
            return data;
        }
    );
};
